import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { CB_59_GROWTH_AT_MANAGE_SUBSCRIPTION } from '@disco/constants/FeatureTypes'
import { getIsTrial } from '@disco/state-management/selectors/business'
import { getIsExpiredSubscription } from '@disco/state-management/selectors/subscription'
import { getConstanceSettings } from '@disco/state-management/selectors/user'

import type { State } from 'types/redux'

import { useSelector } from 'hooks/use-redux'

const isLegacyBillingReplaced = (state: State): boolean =>
  Boolean(getConstanceSettings(state)[CB_59_GROWTH_AT_MANAGE_SUBSCRIPTION]) &&
  !getIsTrial(state) &&
  // Expired subscribers still renew their card on /settings/billing/update from the expired page
  !getIsExpiredSubscription(state)

type Props = {
  /** Where on Billing and usage to land instead */
  redirectTo?: string
}

/**
 * Layout route around the legacy plan change, seats and tracks, card update and add-on screens that
 * Billing and usage replaces: sends subscribers to Billing and usage, and renders the nested routes
 * for trial users and expired subscriptions.
 */
const LegacyBillingRoute = ({
  redirectTo = '/settings/billing',
}: Props): React.ReactNode => {
  const isReplaced = useSelector(isLegacyBillingReplaced)

  return isReplaced ? <Navigate to={redirectTo} replace /> : <Outlet />
}

export default LegacyBillingRoute
